export default "__VITE_ASSET__XufZObLt__"